var _path, _path2, _g, _g2, _circle, _ellipse, _path3, _path4, _path5, _path6, _path7, _ellipse2, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g3, _path15, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccessManWithFlag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 259,
    viewBox: "0 0 300 259",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M298.752 255.797C305.987 241.478 285.308 169.883 141.923 169.883C38.4274 169.883 -9.07413 228.485 1.42751 258.184",
    fill: "url(#paint0_radial_4803_417761)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4803_417761",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 169,
    width: 300,
    height: 90
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M298.752 255.797C305.987 241.478 285.308 169.883 141.923 169.883C38.4274 169.883 -9.07413 228.485 1.42751 258.184",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4803_417761)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.671968,
    cx: 119.807,
    cy: 210.036,
    rx: 7.88551,
    ry: 4.38001,
    fill: "url(#paint1_linear_4803_417761)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.729957,
    cx: 200.295,
    cy: 203.345,
    rx: 12.4416,
    ry: 6.83282,
    fill: "url(#paint2_linear_4803_417761)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.729957,
    cx: 58.7033,
    cy: 185.126,
    rx: 12.4416,
    ry: 6.83282,
    fill: "url(#paint3_linear_4803_417761)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.320685
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 232.689,
    cy: 50.4643,
    rx: 8.41121,
    ry: 8.40963,
    fill: "url(#paint4_linear_4803_417761)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.344 55.5988C237.948 55.4881 234.813 54.795 231.602 53.6265C228.391 52.4579 225.545 50.9745 223.638 49.5195C222.833 48.905 222.245 48.3309 221.915 47.8642C222.012 47.8391 222.121 47.8152 222.243 47.7937C223.168 47.6311 224.518 47.6539 226.126 47.8806L226.713 43.7162C222.053 43.0594 218.673 43.6536 217.699 46.3301C216.282 50.223 222.053 54.6269 230.164 57.5786C238.275 60.5302 245.527 60.8653 246.944 56.9725C247.938 54.2425 245.761 52.0857 241.139 49.2249L238.926 52.8009C240.498 53.774 241.672 54.6338 242.387 55.3416C242.436 55.391 242.483 55.4389 242.527 55.485C241.984 55.5963 241.239 55.6402 240.344 55.5988Z",
    fill: "url(#paint5_linear_4803_417761)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.118 50.4643C241.118 45.8198 237.352 42.0547 232.706 42.0547C228.061 42.0547 225.151 45.0242 224.551 48.3724C224.551 48.3724 229.386 51.3994 231.619 52.0499C232.331 52.2575 233.037 52.5266 233.755 52.7653C234.559 53.0322 235.378 53.2676 236.206 53.4718C236.773 53.6116 237.551 53.8276 238.276 53.9625C239.233 54.1405 240.09 54.2199 240.157 54.2199C240.276 54.2199 240.406 53.6911 240.674 53.0749C240.941 52.4587 241.118 50.4643 241.118 50.4643Z",
    fill: "url(#paint6_linear_4803_417761)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.418364,
    cx: 47.8858,
    cy: 100.073,
    r: 9.80769,
    fill: "url(#paint7_linear_4803_417761)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.425921,
    cx: 154.038,
    cy: 183.733,
    rx: 29.4231,
    ry: 8.07692,
    fill: "url(#paint8_linear_4803_417761)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M133.731 137.574C133.731 137.574 132.925 139.907 132.925 141.547C132.119 155.829 134.116 179.113 134.116 179.113H137.218L141.797 144.078L148.003 179.113H151.054C151.054 179.113 151.457 156.622 150.248 141.547C150.248 139.924 149.546 138.368 149.546 138.368L133.731 137.574Z",
    fill: "url(#paint9_linear_4803_417761)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M130.999 119.495L124.85 120.95L122.752 120.392L109.422 118.456L106.203 118.456L106.19 114.195L106.984 115.831L108.413 116.28C108.413 116.28 109.183 114.725 109.422 114.99C109.66 115.255 109.764 116.348 109.764 116.348L110.955 116.965L125.146 116.965L128.499 114.995L130.999 119.495Z",
    fill: "#FDE7E6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M151.001 119.495L157.334 120.95L159.432 120.392L172.762 118.456L176.409 116.597L177.648 114.122L177.185 114.056L175.2 115.831L173.771 116.28C173.771 116.28 173.001 114.725 172.762 114.99C172.524 115.255 172.42 116.348 172.42 116.348L171.229 116.965L157.038 116.965L153.501 114.995L151.001 119.495Z",
    fill: "#FDE7E6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M154.615 115.254L152.664 120.006H147.893L150 139.741C150 139.741 143.983 140.752 140.802 140.997C137.62 141.242 133.094 139.741 133.094 139.741C133.094 139.741 133.094 132.859 133.094 120.509L128.857 120.006L128.077 115.254C128.077 115.254 132.033 112.477 133.094 112.015C134.154 111.553 137.737 111.031 137.737 111.031L143.406 111.031C143.406 111.031 147.91 111.205 148.761 112.015C149.613 112.825 154.615 115.254 154.615 115.254Z",
    fill: "url(#paint10_linear_4803_417761)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.023 107.578H139.473V112.29H143.023V107.578ZM140.893 114.987C140.893 114.318 139.473 112.29 139.473 112.29H143.023C143.023 112.29 140.893 115.656 140.893 114.987Z",
    fill: "#FECECD"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 141.081,
    cy: 106.14,
    rx: 3.7368,
    ry: 5.29623,
    fill: "#FFE9E9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.978 106.486C137.277 105.487 137.277 103.285 137.875 103.213C138.473 103.141 139.668 103.558 140.864 102.749C141.462 102.305 141.761 102.249 141.761 102.026C144.751 102.558 142.963 104.161 144.452 105.928C144.607 106.112 145.049 105.928 145.049 105.928C145.049 105.928 145.049 101.578 144.751 101.19C144.452 100.802 143.256 99.2391 142.658 100.354C142.658 99.7966 141.462 99.2214 140.266 99.6483C139.071 100.075 137.277 100.911 136.978 102.026C136.679 103.141 136.38 105.371 136.978 106.486Z",
    fill: "#513450"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M134.354 179.109L133.525 180.522C132.98 181.448 132.693 182.503 132.693 183.578C132.693 183.659 132.759 183.725 132.84 183.725H136.698C137.035 183.725 137.309 183.451 137.309 183.114C137.309 181.992 137.103 180.88 136.701 179.833L136.423 179.109H134.354Z",
    fill: "#677285"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M150.647 179.109L151.477 180.522C152.022 181.448 152.309 182.503 152.309 183.578C152.309 183.659 152.243 183.725 152.161 183.725H148.304C147.967 183.725 147.693 183.451 147.693 183.114C147.693 181.992 147.899 180.88 148.301 179.833L148.579 179.109H150.647Z",
    fill: "#677285"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M106.203 5.78906H109.665V181.751C109.665 182.706 108.89 183.481 107.934 183.481C106.978 183.481 106.203 182.706 106.203 181.751V5.78906Z",
    fill: "#D8D8D8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M106.154 5.89394L127.394 10.9458C135.217 12.8067 143.46 11.4733 150.298 7.24074C159.946 1.26898 171.747 -0.113055 182.514 3.46784L189.808 5.89394L184.039 49.0624L182.415 48.3998C171.968 44.1371 160.038 45.792 151.146 52.7375C144.029 58.2959 134.459 59.5599 126.143 56.0399L106.154 47.5783V5.89394Z",
    fill: "url(#paint11_linear_4803_417761)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M157.376 16.0121C158.527 14.7064 160.509 14.6025 161.79 15.7807C163.058 16.9461 163.162 18.9281 162.023 20.2197L143.012 41.7818C142.453 42.4157 141.676 42.7859 140.853 42.829C140.03 42.8722 139.219 42.5852 138.597 42.0133L127.465 31.7778C126.197 30.6124 126.093 28.6304 127.232 27.3389C128.383 26.0332 130.365 25.9294 131.647 27.1075L140.453 35.2048L157.376 16.0121Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4803_417761",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 126,
    y: 14,
    width: 37,
    height: 29
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M157.376 16.0121C158.527 14.7064 160.509 14.6025 161.79 15.7807C163.058 16.9461 163.162 18.9281 162.023 20.2197L143.012 41.7818C142.453 42.4157 141.676 42.7859 140.853 42.829C140.03 42.8722 139.219 42.5852 138.597 42.0133L127.465 31.7778C126.197 30.6124 126.093 28.6304 127.232 27.3389C128.383 26.0332 130.365 25.9294 131.647 27.1075L140.453 35.2048L157.376 16.0121Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4803_417761)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M140.595 35.0201L133.21 42.9174L125.13 37.5637L136.655 25.9831L140.595 35.0201Z",
    fill: "url(#paint12_linear_4803_417761)"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M105.461 115.141C105.461 115.141 107.192 114.276 107.192 114.564C107.192 114.853 107.192 118.026 107.192 118.026L106.038 118.603L105.461 115.141Z",
    fill: "#FFE9E9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4803_417761",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(130.111 200.506) rotate(-90) scale(51.3403 536.198)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEDF0",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536775,
    stopColor: "#EBEDF0",
    stopOpacity: 0.845525
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E4E7",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4803_417761",
    x1: 113.46,
    y1: 208.875,
    x2: 115.863,
    y2: 214.013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E7EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D6DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4803_417761",
    x1: 189.848,
    y1: 202.706,
    x2: 194.244,
    y2: 211.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E7EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D6DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4803_417761",
    x1: 50.7703,
    y1: 185.236,
    x2: 53.2577,
    y2: 195.146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4803_417761",
    x1: 221.198,
    y1: 44.6735,
    x2: 225.404,
    y2: 59.2136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.717538,
    stopColor: "#E1E7EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC3CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4803_417761",
    x1: 224.763,
    y1: 53.7541,
    x2: 245.384,
    y2: 61.2593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAC6D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F8F9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4803_417761",
    x1: 229.596,
    y1: 49.7406,
    x2: 232.346,
    y2: 55.2969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E7EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D6DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4803_417761",
    x1: 60.7797,
    y1: 102.984,
    x2: 50.9863,
    y2: 86.4451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE2E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E3EBEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF6F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4803_417761",
    x1: 131.953,
    y1: 184.691,
    x2: 148.479,
    y2: 210.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CDD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6CFD3",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4803_417761",
    x1: 151.086,
    y1: 179.113,
    x2: 151.086,
    y2: 137.886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1A7B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B8195"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4803_417761",
    x1: 168.041,
    y1: 124.729,
    x2: 142.501,
    y2: 153.941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E9F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2DAE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4803_417761",
    x1: 106,
    y1: 48.5,
    x2: 186.5,
    y2: 12.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#459D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42B339"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4803_417761",
    x1: 128.829,
    y1: 34.6358,
    x2: 136.298,
    y2: 39.9051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67D666",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67D666",
    stopOpacity: 0.2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessManWithFlag);
export default __webpack_public_path__ + "static/media/success-man-with-flag.94170e701e5396b81f4f8506af832937.svg";
export { ForwardRef as ReactComponent };